/**
 * logError: the console in development; in production, the server log.
 *
 * Production used to print nothing, so the field list failing on one load in
 * six (2026-10-13) reached nobody. Now each error is posted to
 * /api/client-errors/ (myproject/api_client_errors.py), at most MAX_REPORTS
 * per page load so a failing poll cannot flood it, never for that endpoint's
 * own failure, and never throwing.
 */
import axios from '../config/axios';

const MAX_REPORTS = 5;
let sent = 0;

const describe = (err) => ({
  message: String(err?.message || err || '').slice(0, 500),
  status: err?.response?.status ?? (err?.request ? 0 : ''),
  url: String(err?.config?.url || '').slice(0, 300),
});

export const logError = (err, context = '') => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(context, err);
    return;
  }
  try {
    const info = describe(err);
    if (sent >= MAX_REPORTS || info.url.includes('client-errors')) return;
    sent += 1;
    const page = typeof window !== 'undefined' ? window.location.pathname : '';
    axios.post('/api/client-errors/', { ...info, context: String(context).slice(0, 120), page })
      .catch(() => { /* reporting must never raise or recurse */ });
  } catch (_) { /* reporting must never raise */ }
};

/** Test hook: forget how many reports this page sent. */
export const _resetErrorReports = () => { sent = 0; };
